import type { Specialization } from '@/types/reference';

type DomainSelectOption = {
  value: string;
  label: string;
};

export function flattenDomainSelectOptions(
  domains: Specialization[],
  translate: (key: string) => string,
  prefix = '',
  seen: Set<string> = new Set(),
): DomainSelectOption[] {
  const options: DomainSelectOption[] = [];
  domains.forEach((domain) => {
    if (!seen.has(domain.id)) {
      seen.add(domain.id);
      options.push({
        value: domain.id,
        label: `${prefix}${translate(domain.name)}`,
      });
    }
    if (domain.sub_domains?.length) {
      options.push(
        ...flattenDomainSelectOptions(
          domain.sub_domains,
          translate,
          `${prefix}  `,
          seen,
        ),
      );
    }
  });
  return options;
}

/** Add options for selected domain IDs missing from the reference list (e.g. hidden or "Other"). */
export function mergeMissingDomainSelectOptions(
  options: DomainSelectOption[],
  selected: Array<string | Pick<Specialization, 'id' | 'name'>> | undefined,
  translate: (key: string) => string,
): DomainSelectOption[] {
  if (!selected?.length) return options;

  const knownIds = new Set(options.map((option) => option.value));
  const extras: DomainSelectOption[] = [];

  for (const item of selected) {
    const id = typeof item === 'string' ? item : item.id;
    if (knownIds.has(id)) continue;
    knownIds.add(id);
    const name = typeof item === 'string' ? id : item.name;
    extras.push({ value: id, label: translate(name) });
  }

  return extras.length > 0 ? [...options, ...extras] : options;
}
